import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CanvasEvents } from './canvas.model';
import { CanvasService } from './canvas.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HealthAppService } from 'src/app/services/explore-health/health-app.service';
import { CanvasHelperService } from './canvas-helper.service';

@Component({
  selector: 'app-content-generation-canvas',
  templateUrl: './content-generation-canvas.component.html',
  styleUrl: './content-generation-canvas.component.scss',
})
export class ContentGenerationCanvasComponent implements OnInit, OnDestroy {
  public fetchSessionMessages = false;
  private canvasEventsSub!: Subscription;
  get data() {
    return this.dialogData ?? null;
  }

  constructor(
    public canvasService: CanvasService,
    private readonly helper: CanvasHelperService,
    private readonly haService: HealthAppService,
    @Inject(MatDialogRef)
    private readonly matDialogRef: MatDialogRef<ContentGenerationCanvasComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) {}

  public getCurrentContextNofo() {
    return this.data?.grantDetails?.grantOpportunityNumber ?? null;
  }

  ngOnInit(): void {
    this.fetchSessionMessages = true;
    this.registerCanvasEvents();
    this.checkCurrentSession();
    this.getConversationSettings();
    this.getAppSettings();
  }

  getConversationSettings() {
    this.canvasService.getConversationSettings().subscribe({
      next: (settings) => {
        this.canvasService.conversationSettings = settings;
      },
      error: (error) => {
        console.error('Error fetching conversation settings:', error);
      },
    });
  }
  getAppSettings() {
    this.canvasService.getAppSettings().subscribe({
      next: (settings) => {
        this.canvasService.appSettings = settings;
      },
      error: (error) => {
        console.error('Error fetching app settings:', error);
      },
    });
  }
  ngOnDestroy(): void {
    this.canvasService.clearInstance();
    this.canvasEventsSub?.unsubscribe();
    this.canvasService.ngOnDestroy();
  }

  expandCanvas() {
    this.haService.chatBotDialogOpened = false;
    this.canvasService.isEmbededChat = false;
    this.data.isEmbededChat = false;

    this.matDialogRef.updateSize('99vw', '99vh');
    this.matDialogRef.addPanelClass('chatbot-dialog');
    this.matDialogRef.updatePosition();
  }

  registerCanvasEvents() {
    this.canvasEventsSub = this.canvasService.canvasEvents$.subscribe(
      (event) => {
        switch (event.type) {
          case CanvasEvents.CLEAR_INSTANCE:
          case CanvasEvents.FETCH_SESSIONS_SUCCESS:
          case CanvasEvents.FETCH_CHAT_MESSAGES_SUCCESS:
          case CanvasEvents.FETCH_CHAT_MESSAGES_ERROR:
          case CanvasEvents.NEW_SESSION_CREATED:
          case CanvasEvents.DELETE_SESSION_ERROR:
          case CanvasEvents.SOCKET_INIT:
            this.fetchSessionMessages = false;
            break;
          case CanvasEvents.FETCH_SESSIONS_ERROR:
            this.fetchSessionMessages = false;
            this.helper.showFailedToLoadSessionsDialog();
            break;
          case CanvasEvents.FETCH_SESSIONS:
          case CanvasEvents.FETCH_CHAT_MESSAGES:
            this.fetchSessionMessages = true;
            break;
          case CanvasEvents.DELETE_SESSION_SUCCESS:
          case CanvasEvents.DELETE_SESSION_SUCCESS_WITHOUT_HIGHLIGHT:
            this.fetchSessionMessages = false;
            this.canvasService.getSessions(
              event.type === CanvasEvents.DELETE_SESSION_SUCCESS
            );
            break;
        }
      }
    );
  }

  checkCurrentSession() {
    this.canvasService.getSessions(true, this.data.startNewChat);
    this.canvasService.isEmbededChat = this.data.isEmbededChat;
  }

  closeCanvas() {
    this.matDialogRef?.close();
  }
}
